<template lang="pug">
    .settings-dashboard
        .settings-dashboard-wrapper
            settings-page-head

            .profit-panel
                .profit-plate.daily
                    .profit-plate__title DAILY
                    span.profit-price.price_daily {{ totals.day || 0 | currency }}
                .profit-plate.weekly
                    .profit-plate__title WEEKLY
                    span.profit-price.price_weekly {{ totals.week || 0 | currency }}
                .profit-plate.monthly
                    .profit-plate__title MONTHLY
                    span.profit-price.price_monthly {{ totals.month || 0 | currency }}
                .profit-plate.yearly
                    .profit-plate__title YEARLY
                    span.profit-price.price_yearly {{ totals.year || 0 | currency }}

            .dashboard-table-wrapper
                .dashboard-table-menu
                    .dashboard-table-menu__item(@click="showReferred = false" :class="{ 'active': !showReferred }") Payouts
                    .dashboard-table-menu__item(@click="showReferred = true" :class="{ 'active': showReferred }") Referrals

                .dashboard-table-items-wrap
                    .dashboard-table.dashboard-table--6-columns
                        .dashboard-table__head
                            template(v-if="showReferred")
                                .dashboard-table__head-item referred by
                                .dashboard-table__head-item date
                                .dashboard-table__head-item payout
                            template(v-else)
                                .dashboard-table__head-item product
                                .dashboard-table__head-item price
                                .dashboard-table__head-item username
                                .dashboard-table__head-item purchase date
                                .dashboard-table__head-item platform fee
                            .dashboard-table__head-item status
                        .dashboard-table__item(v-for="payout in payouts" :key="payout.id")
                            template(v-if="showReferred")
                                .dashboard-table__item-content.name {{ payout.referred_by.data.name }}
                                .dashboard-table__item-content.purchase_date {{ payout.created_at.substring(0, 10) }}
                                .dashboard-table__item-content.price {{ payout.amount | currency }}
                            template(v-else)
                                .dashboard-table__item-content.name {{ payout.product.data.title }}
                                .dashboard-table__item-content.price {{ payout.total | currency }}
                                .dashboard-table__item-content.username {{ payout.order_user.data.name }}
                                .dashboard-table__item-content.purchase_date {{ payout.created_at.substring(0, 10) }}
                                .dashboard-table__item-content.platform_fee {{ payout.total - payout.amount | currency }}
                            .dashboard-table__item-content.status
                                .dashboard-table__item-status(:class="payout.state") {{ payout.state }}

                dashboard-table-paging(v-if="pages > 1" :page="page" :pages="pages" @click="load($event.page)")

        .re-loading(v-show="loading")
            static-loader-control

</template>

<script>
const PAGE_SIZE = 10

export default {
    name: 'settings-earning-dashboard',

    data() { return {
        totals: {},
        payouts: [],
        showReferred: false,
        loading: false,
        pages: 1,
        page: 1,
    }},

    async created() {
        await this.load()
    },

    watch: {
        showReferred() {
            this.load()
        }
    },

    methods: {
        async load(page = 1) {
            try {
                this.loading = true

                const { data: totals } = await axios.get('/api/customer/user/payout/total')
                this.totals = totals
        
                const query = {
                    include: 'item.order,referred_by',
                    where: JSON.stringify({
                        state: ['deferred', 'pending', 'paying', 'paid', 'reverting', 'reverted', 'failed', 'canceled'],
                        referred: this.showReferred,
                    }),
                    page_size: PAGE_SIZE,
                    page: page,
                }
        
                const { data: { data: payouts, meta: { pagination } } } = await axios.get('/api/customer/user/payout?' + (new URLSearchParams(query).toString()))
        
                this.page = pagination.current_page
                this.pages = pagination.total_pages

                this.payouts = payouts
            } finally {
                this.loading = false
            }
        }
    }
}
</script>
